var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MessageArea',{attrs:{"title":"评论区","subTitle":`共${_vm.data.total}条评论`,"list":_vm.data.rows,"isListLoading":_vm.isLoading},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }